/* eslint-disable angular/document-service */
/* eslint-disable angular/window-service */
/* eslint-disable angular/timeout-service */
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { ToastNotification, NOTIFICATION_TYPES } from '../ToastNotification';

function VideoButtons({
    changeVideo = () => { },
    selectedVideo = {},
    selectedEnvelope = {},
    libraryVideos,
    editVideo = () => { },
    slug = '',
    thumbnail = '',
    thumbnailType = 1,
    disable = false,
    disableLinks = false,
    isMobile = false,
}) {
    const [url, setUrl] = useState('');
    const [copied, setCopied] = useState(false);
    const [isOpenConfirmation, setIsOpenConfirmation] = useState(false);

    useEffect(() => {
        const bizSlug = slug ? slug + '.' : '';

        if (selectedVideo) {
            const link = window.location.protocol + '//' + bizSlug + config.hostUrl + '/video/personal/' + selectedVideo.id_string;
            setUrl(link);
        }

        // Batch state updates into a single call
    }, [selectedVideo]);

    const updatedLink = url + '?type=' + (thumbnailType === 2 ? 'envelope' : 'video');

    const containerStyle = {
        textAlign: 'center',
    };

    const linkStyle = {
        color: '#0645AD',
    };

    const textStyle = {
        fontSize: '16px',
        fontFamily: "'Lato', sans-serif",
        fontWeight: '400',
        lineHeight: '1.3',
        marginTop: '10px',
    };

    const buttonStyle = {
        backgroundColor: '#3367F2',
        color: '#fff',
        marginTop: '10px',
        verticalAlign: 'middle',
        fontFamily: "'Lato', sans-serif",
        fontSize: '16px',
        lineHeight: '1.25em',
        padding: '10px 16px',
        borderRadius: '100px',
        border: 'none',
        textDecoration: 'none',
        fontWeight: '400',
        margin: '24px auto',
    };

    const landingPageCommonContent = () => <>
        {selectedVideo && selectedVideo.message
            ? <p style={{ ...textStyle, ...linkStyle }}>
                <a
                    href={updatedLink}
                    target="_blank"
                    rel="noopener noreferrer">
                    {selectedVideo.message}
                </a></p>
            : <p style={textStyle}>Click <a style={linkStyle} href={updatedLink} target="_blank" rel="noopener noreferrer">here</a> to see your personal video!
            </p>
        }
        {selectedVideo && selectedVideo.button_enabled && selectedVideo.show_in_email && !!(selectedVideo.button_text) && !!(selectedVideo.button_url)
            ? <a type="button"
                style={buttonStyle}
                href={selectedVideo.button_url}
                target="_blank"
                rel="noopener noreferrer">
                {selectedVideo.button_text}
            </a>
            : null}
    </>;


    function openEditModal(e) {
        editVideo(e, libraryVideos[selectedVideo.library_video_id], selectedVideo);
    }

    function copyContent() {
        setCopied(true);
        // Use setTimeout with 0ms delay to ensure the content is read after updates
        setTimeout(() => {
            const copyEl = document.getElementById(selectedVideo.thumbnail_type === 2 ? 'landing-copy' : 'personal-video-copy').innerHTML;

            // Try modern clipboard API first (works on both mobile and desktop)
            if (navigator.clipboard && navigator.clipboard.write) {
                const data = new ClipboardItem({
                    'text/plain': new Blob([copyEl], { type: 'text/plain' }),
                    'text/html': new Blob([copyEl], { type: 'text/html' }),
                });

                navigator.clipboard.write([data]).then(() => {
                    setIsOpenConfirmation(true);
                    setTimeout(() => setIsOpenConfirmation(false), 3000);
                    setTimeout(() => setCopied(false), 100);
                });
            } else if (navigator.clipboard && navigator.clipboard.writeText) {
                // Fallback to writeText with full HTML as plain text
                navigator.clipboard.writeText(copyEl).then(() => {
                    setIsOpenConfirmation(true);
                    setTimeout(() => setIsOpenConfirmation(false), 3000);
                    setTimeout(() => setCopied(false), 100);
                });
            } else {
                // Fallback for older browsers (both mobile and desktop) - textarea method
                fallbackCopyForOldMobileBrowsers(copyEl);
            }
        }, 0);
    }

    function fallbackCopyForOldMobileBrowsers(copyEl) {
        // Create a temporary textarea element
        const textArea = document.createElement('textarea');
        textArea.value = copyEl;
        textArea.style.position = 'fixed';
        textArea.style.left = '-999999px';
        textArea.style.top = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();

        try {
            document.execCommand('copy');
            setIsOpenConfirmation(true);
            setTimeout(() => setIsOpenConfirmation(false), 3000);
            setTimeout(() => setCopied(false), 100);
        } catch (err) {
            console.error('Fallback copy failed:', err);
        }

        document.body.removeChild(textArea);
    }


    function handleCopyUrl() {
        setIsOpenConfirmation(false);

        if (navigator.clipboard && navigator.clipboard.writeText) {
            navigator.clipboard.writeText(url)
                .then(() => {
                    setIsOpenConfirmation(true);
                })
                .catch((err) => {
                    console.error('Failed to copy link: ', err);
                });
        } else {
            // Fallback for older browsers
            const textArea = document.createElement('textarea');
            textArea.value = url;
            textArea.style.position = 'fixed';
            textArea.style.left = '-999999px';
            textArea.style.top = '-999999px';
            document.body.appendChild(textArea);
            textArea.focus();
            textArea.select();

            try {
                document.execCommand('copy');
                setIsOpenConfirmation(true);
            } catch (err) {
                console.error('Fallback copy failed:', err);
            }

            document.body.removeChild(textArea);
        }
    }

    return (
        <div className={isMobile ? 'flex' : ''} style={isMobile ? {} : { display: '-webkit-box' }}>
            <button type="button"
                className={`btn btn--destructive font-size-16px ${isMobile ? 'width-50' : ''}`}
                onClick={changeVideo}
                disabled={disable}>
                {isMobile
                    ? 'Re-Record'
                    : 'Change Video'
                }
                <i className="fas fa-camera margin-l-8px"></i>
            </button>
            <button type="button"
                disabled={disable}
                style={{ display: `${isMobile ? 'flex' : 'initial'}`, alignItems: 'center' }}
                className="btn btn--primary-alt font-size-16px margin-l-24px none lg-inline-block"
                onClick={(e) => openEditModal(e)}>
                Edit Video
                <i className='fa fa-edit margin-l-8px'></i>
            </button>
            {disableLinks
                ? <button type="button"
                    disabled={true}
                    className="btn btn--primary font-size-16px margin-l-24px none lg-inline-block"
                    onClick={() => copyContent()}>
                    Preview Page
                    <i className={`${copied ? 'fa fa-check' : 'fas fa-external-link-alt'} margin-l-8px`}></i>
                </button>
                : <a type="button"
                    className="btn btn--primary-alt font-size-16px margin-l-24px none lg-inline-block"
                    href={updatedLink + '&&source=export'}
                    target="_blank"
                    rel="noopener noreferrer">
                    Preview Page
                    <i className="fas fa-external-link-alt margin-l-8px"></i>
                </a>
            }
            <div className={`margin-l-24px ${isMobile ? 'width-50' : ''}`}>
                <button type="button"
                    disabled={disableLinks}
                    className={`btn btn--primary font-size-16px ${isMobile ? 'width-100' : ''}`}
                    onClick={() => copyContent()}>
                    {isMobile
                        ? 'Copy Link'
                        : 'Copy Link + Thumbnail'
                    }
                    <i className={`${copied ? 'fa fa-check' : 'fas fa-link'} margin-l-8px`}></i>
                </button>
                {disableLinks
                    ? <div>Copy URL Only</div>
                    : <a style={{
                        textDecorationLine: 'underline',
                        fontSize: '10px',
                        marginTop: 4,
                        cursor: 'pointer',
                        color: '#565656',
                        display: 'block',
                    }} onClick={handleCopyUrl}> Copy URL Only </a>
                }
                <ToastNotification isVisible={isOpenConfirmation} notificationType={NOTIFICATION_TYPES.SUCCESS} msg="URL Copied" />
            </div>

            <div id="personal-video-copy" style={{ display: 'none' }}>
                <div style={containerStyle} >
                    <a href={updatedLink} target="_blank" rel="noopener noreferrer">
                        {thumbnail ? <img src={thumbnail} alt="Thumbnail" width={500} height={375}></img> : 'Click here to view your video!'}
                    </a>
                    {landingPageCommonContent()}
                </div>
            </div>

            <div id="landing-copy" style={{ display: 'none' }}>
                <div style={containerStyle} >
                    <a href={updatedLink} target="_blank" rel="noopener noreferrer">
                        {Object.keys(selectedEnvelope).length > 0 ? <img src={`${selectedEnvelope.path}/front.jpg`} alt="Envelope" width={451} height={328}></img> : 'Click here to view your video!'}
                    </a>
                    {landingPageCommonContent()}
                </div>
            </div>
        </div>
    );
}

VideoButtons.propTypes = {
    changeVideo: PropTypes.func,
    disableLinks: PropTypes.bool,
    rerecord: PropTypes.func,
    editVideo: PropTypes.func,
    libraryVideos: PropTypes.object,
    selectedVideo: PropTypes.object,
    selectedEnvelope: PropTypes.object,
    slug: PropTypes.string,
    disable: PropTypes.bool,
    thumbnail: PropTypes.string,
    thumbnailType: PropTypes.number,
    isMobile: PropTypes.bool,
};
export default VideoButtons;
